import { render, staticRenderFns } from "./ApiTokensTable.vue?vue&type=template&id=0c342e1a&scoped=true"
import script from "./ApiTokensTable.vue?vue&type=script&lang=js"
export * from "./ApiTokensTable.vue?vue&type=script&lang=js"
import style0 from "../../components/dataIterator/TableCustomSort.scss?vue&type=style&index=0&id=0c342e1a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c342e1a",
  null
  
)

export default component.exports